import { render } from "./Create.vue?vue&type=template&id=3e1f82f9&bindings={\"errors\":\"props\",\"noticeable_roles\":\"props\",\"form\":\"data\",\"create\":\"options\"}"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3e1f82f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e1f82f9')) {
    api.reload('3e1f82f9', script)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=3e1f82f9&bindings={\"errors\":\"props\",\"noticeable_roles\":\"props\",\"form\":\"data\",\"create\":\"options\"}", () => {
    api.rerender('3e1f82f9', render)
  })

}

script.__file = "resources/js/Pages/Notices/Create.vue"

export default script